/**
 * Outline SVG icon module.
 */
import * as React from "react";
/**
 * Switch Vertical (outline) SVG icon. Generated wrapper that forwards props to the root svg.
 *
 * @param {React.SVGProps<SVGSVGElement>} props SVG element props.
 * @returns {JSX.Element}
 */
const SvgSwitchVertical = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m47 50-4-4m-6 0V34zm0-12-4 4zm0 0 4 4zm10 4v12zm0 12 4-4z"
    />
  </svg>
);
export default SvgSwitchVertical;
